/*
 * @Author: Ashley.Liu
 * @Date: 2022-03-14 13:36:10
 * @LastEditTime: 2022-06-22 13:17:26
 * @Description: desc
 */
import { Button, Input, Dropdown, Loading, Sticky,
    Tabs, Table, Message, Form, Breadcrumb, Row, Col, Radio, RadioGroup, Dialog, Upload,
    Tag, Checkbox, Select, Tooltip, InputNumber, MessageBox, Popover, Menu,
    Collapse, Pagination, Tree, CheckboxGroup, DatePicker, Locale,
    TimePicker,
    Progress,
    Scrollbar,
    Steps,
    Notification,
    Drawer,
    Autocomplete,
    Switch,
    Badge,
    Avatar,
    Cascader,
    /* eslint-disable no-unused-vars */
    Style } from '@zoom/zoom-ui'
import AsyncUI from '@zoom/async-ui'

import Vue from 'vue'

// const Vue = window.Vue
Vue.use(Button)
Vue.use(Locale)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(Loading)
Vue.use(Sticky)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(Message)
Vue.use(Form)
Vue.use(Breadcrumb)
Vue.use(Row)
Vue.use(Col)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Tag)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Tooltip)
Vue.use(InputNumber)
Vue.use(MessageBox)
Vue.use(Popover)
Vue.use(Menu)
Vue.use(Collapse)
Vue.use(Pagination)
Vue.use(Tree)
Vue.use(CheckboxGroup)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Progress)
Vue.use(Scrollbar)
Vue.use(Steps)
Vue.use(Notification)
Vue.use(Drawer)
Vue.use(Autocomplete)
Vue.use(Switch)
Vue.use(Badge)
Vue.use(Avatar)
Vue.use(Cascader)
Vue.use(AsyncUI)
